import Config from './config.js'
import Util from './util.js'
import Dingtalk from './dingtalk.js'

const Auth = {
  getToken() {
    return localStorage.getItem(Config.tokenKey) || ''
  },

  setSession(token, account) {
    if (token) localStorage.setItem(Config.tokenKey, token)
    if (account) localStorage.setItem(Config.accountKey, JSON.stringify(account))
  },

  hasSession() {
    return !!(this.getToken() && localStorage.getItem(Config.accountKey))
  },

  toLogin() {
    const returnUrl = location.pathname + location.search + location.hash
    location.replace('/login/?returnUrl=' + encodeURIComponent(returnUrl))
  },

  exit() {
    localStorage.removeItem(Config.tokenKey)
    localStorage.removeItem(Config.accountKey)
    this.toLogin()
  },

  async ensureAuth() {
    if (this.hasSession()) return true

    if (Dingtalk.isDingTalk()) {
      const data = await Dingtalk.loginByDingTalk()
      if (data && data.token) return true
      Util.info('钉钉免登失败，请确认企业已启用钉钉集成且账号已同步', 'error')
      return false
    }
    this.toLogin()
    return false
  },

  async refreshAccount() {
    const data = await Util.ajax({
      url: Util.getApiUrl('/main/getAccount')
    })
    if (data.roleId === 500) {
      if (Dingtalk.isDingTalk()) {
        const loginData = await Dingtalk.loginByDingTalk()
        if (loginData && loginData.token) {
          return this.refreshAccount()
        }
        Util.info('钉钉免登失败，请确认账号已同步', 'error')
        return null
      }
      this.exit()
      return null
    }
    this.setSession(this.getToken(), data)
    return data
  }
}

export default Auth
